import { EChipsSelectMenuPlacement } from '@components/common/GroupSelect/enum';
import { MAX_WIDTH } from '@components/common/GroupSelectKpi/ValueContent/InvisibleItems/constantsе';

import { InvisibleItemsPosition } from '@interfaces/invisibleItems';
import { TChipsSelectMenuPlacementValues } from '@components/common/GroupSelect/GroupSelect.types';

interface UpdatePositionOptions {
	anchorElement: HTMLElement | null;
	menuPlacement: TChipsSelectMenuPlacementValues;
	maxHeight: number;
	setPosition: (pos: InvisibleItemsPosition) => void;
	setPortalContainer: (el: HTMLElement) => void;
	maxWidth?: number;
}

export const updatePosition = ({
	anchorElement,
	menuPlacement,
	maxHeight,
	setPosition,
	setPortalContainer,
	maxWidth = MAX_WIDTH,
}: UpdatePositionOptions): void => {
	if (!anchorElement) return;

	const rect = anchorElement.getBoundingClientRect();

	let top = 0;
	let left = 0;

	switch (menuPlacement) {
		case EChipsSelectMenuPlacement.topEnd:
			top = rect.top + window.scrollY - maxHeight - 10;
			left = rect.left + window.scrollX;
			break;
		case EChipsSelectMenuPlacement.bottomEnd:
			top = rect.bottom + window.scrollY + 10;
			left = rect.left + window.scrollX;
			break;
		case EChipsSelectMenuPlacement.top:
			top = rect.top + window.scrollY - maxHeight - 10;
			left = rect.right + window.scrollX - maxWidth;
			break;
		case EChipsSelectMenuPlacement.bottom:
		default:
			top = rect.bottom + window.scrollY + 10;
			left = rect.right + window.scrollX - maxWidth;
			break;
	}

	setPosition({
		top,
		left,
		width: rect.width,
		height: rect.height,
	});

	setPortalContainer(document.body);
};
